import React from "react"
import { generalStyles as gs } from "../../styles/styles"
import useTarif from "../../../hooks/useTarif"
import { ENTITE_TYPE_SOCIETE, ENTITE_TYPE_ASSURANCE } from "./Entite"

// Tarif horaire MO de base selon le type d'entité (société / assurance / privé),
// lu du snapshot de tarification du Master (useTarif).
const basePrixMO = (tarif, type) => {
	if (type === ENTITE_TYPE_SOCIETE) return tarif.prixHoraireSociete
	if (type === ENTITE_TYPE_ASSURANCE) return tarif.prixHoraireAssurance
	return tarif.prixHoraire // personne physique / client de passage
}

// Champs « Main d'œuvre » d'une entité, partagés par ClientFicheV2 et
// EntiteFicheV2 :
//  - Prix vente main d'œuvre : tarif de base (lecture seule) selon le type ;
//  - Rabais vente main d'œuvre : rabais forfaitaire HT par heure, stocké dans
//    extra_data.prix_vente_unitaire_mo (nom historique), appliqué automatiquement
//    à l'ajout d'une ligne MO sur la fiche atelier.
const MainOeuvreRabaisV2 = ({ type, extraData, updateExtra }) => {
	const tarif = useTarif()
	return (
		<>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Prix vente main d'œuvre</label>
				<input
					style={gs.inputReadonly}
					value={basePrixMO(tarif, type)}
					readOnly
				/>
			</div>
			<div style={gs.fieldRow}>
				<label style={gs.label}>Rabais vente main d'œuvre</label>
				<input
					type="number"
					style={gs.input}
					value={(extraData || {}).prix_vente_unitaire_mo ?? ""}
					onChange={(e) =>
						updateExtra("prix_vente_unitaire_mo", e.target.value)
					}
				/>
			</div>
		</>
	)
}

export default MainOeuvreRabaisV2
